"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _skeletonLoadingModule = _interopRequireDefault(require("./skeleton-loading.module.css"));

var SkeletonLoading = function SkeletonLoading(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_skeletonLoadingModule.default.skeleton, className)
  }, children);
};

SkeletonLoading.propTypes = {
  /** additional class name if applicable */
  className: _propTypes.default.string,

  /** element which this component is a wrapper around */
  children: _propTypes.default.node
};
SkeletonLoading.defaultProps = {
  className: '',
  children: null
};
var _default = SkeletonLoading;
exports.default = _default;